import React from 'react';

// The "requested configuration" panel shown beside the annotator: what the
// logo and lens overlay were supposed to look like for this frame.
function ConfigSidebar({ configData }) {
  if (!configData) return null;

  const logoImages = configData.logo_data?.logo_images || [];
  const lensImages = configData.lens_data?.lens_images || [];
  const hasLogo = configData.needs_logo && logoImages.length > 0;

  return (
    <div className="w-64 border-r border-gray-200 bg-gray-50 overflow-y-auto flex-shrink-0">
      <div className="p-4 space-y-4">
        <div className="pb-2 border-b border-gray-300">
          <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide">
            Requested Configuration
          </h3>
        </div>

        <div className="space-y-2">
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
            Logo
          </div>
          {hasLogo ? (
            <div className="p-2 bg-white rounded-lg border border-gray-300 shadow-sm">
              <div className="flex flex-wrap gap-2 justify-center">
                {logoImages.map((logo, idx) => (
                  <div key={idx} className="flex flex-col items-center gap-2 p-2 bg-gray-50 rounded border border-gray-200">
                    <div
                      className="w-14 h-14 flex items-center justify-center rounded border-2 border-gray-300 p-1.5"
                      style={{ backgroundColor: '#808080' }}
                    >
                      <img
                        src={logo.url}
                        alt={`${logo.position} ${logo.color}`}
                        className="max-w-full max-h-full object-contain"
                        title={`${logo.position} - ${logo.color}`}
                      />
                    </div>
                    <div className="text-center">
                      <div className="text-xs font-semibold text-gray-700 capitalize leading-tight">
                        {logo.position?.replace('_', ' ')}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="p-3 bg-white rounded-lg border border-gray-300 text-center">
              <div className="text-xs text-gray-500">No logo required</div>
            </div>
          )}
        </div>

        <div className="space-y-2">
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
            Lens Overlay
          </div>
          {lensImages.length > 0 ? (
            <div className="p-2 bg-white rounded-lg border border-gray-300 shadow-sm">
              <div className="flex flex-wrap gap-2 justify-center">
                {lensImages.map((lens, idx) => (
                  <div key={idx} className="flex flex-col items-center gap-2 p-2 bg-gray-50 rounded border border-gray-200">
                    <div className="w-14 h-14 flex items-center justify-center bg-white rounded border-2 border-gray-300 overflow-hidden">
                      <img src={lens.url} alt={lens.type} className="w-full h-full object-cover" title={lens.type} />
                    </div>
                    <div className="text-center">
                      <div className="text-xs font-semibold text-gray-700 capitalize leading-tight">
                        {lens.type}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="p-3 bg-white rounded-lg border border-gray-300 text-center">
              <div className="text-xs text-gray-500">No lens overlay</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConfigSidebar;
